import { useState } from "react";
import { Input } from "@/components/ui/input";
import { PageHeader, DataTable } from "@/components/kit";
import { useApi, dt } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const J = (v) => (v === null || v === undefined ? "" : typeof v === "object" ? JSON.stringify(v) : String(v));

export default function Audit() {
  const { branchName } = useAuth();
  const [f, setF] = useState({ q: "", action: "", date_from: "", date_to: "" });
  const { data, loading } = useApi("/audit", f);
  return (
    <div className="fade-up">
      <PageHeader title="Audit Trail" subtitle="Immutable log of sensitive actions — cannot be deleted by users" testid="audit-header">
        <Input data-testid="audit-search" className="w-44" placeholder="User / plate / entity id" value={f.q} onChange={(e) => setF({ ...f, q: e.target.value })} />
        <Input data-testid="audit-action" className="w-40" placeholder="Action (e.g. override)" value={f.action} onChange={(e) => setF({ ...f, action: e.target.value })} />
        <Input type="date" data-testid="audit-from" className="w-40" value={f.date_from} onChange={(e) => setF({ ...f, date_from: e.target.value })} />
        <Input type="date" data-testid="audit-to" className="w-40" value={f.date_to} onChange={(e) => setF({ ...f, date_to: e.target.value })} />
      </PageHeader>
      <DataTable testid="audit-table" loading={loading} rows={data} columns={[
        { key: "at", label: "Date/time", render: (r) => <span className="font-mono text-xs">{dt(r.at, { second: "2-digit", year: "numeric" })}</span> },
        { key: "user_name", label: "User", render: (r) => <span><b>{r.user_name}</b> <span className="text-xs text-muted-foreground">{r.user_role}</span></span> },
        { key: "action", label: "Action", render: (r) => <span className="font-mono text-xs">{r.action}</span> },
        { key: "branch", label: "Branch", render: (r) => (r.branch_id ? branchName(r.branch_id) : "—") },
        { key: "entity", label: "Entity", render: (r) => <span className="text-xs">{r.entity} {r.entity_id ? `#${String(r.entity_id).slice(0, 8)}` : ""}</span> },
        { key: "plate", label: "Vehicle", render: (r) => (r.plate ? <span className="plate text-xs">{r.plate}</span> : "—") },
        { key: "prev", label: "Previous", render: (r) => <span className="block max-w-[200px] truncate font-mono text-[11px] text-muted-foreground" title={J(r.prev)}>{J(r.prev)}</span> },
        { key: "new", label: "New", render: (r) => <span className="block max-w-[220px] truncate font-mono text-[11px]" title={J(r.new) + " " + J(r.note)}>{J(r.new) || J(r.note)}</span> },
        { key: "ip", label: "IP / device", render: (r) => <span className="block max-w-[140px] truncate font-mono text-[11px]" title={r.client}>{r.ip || "—"}</span> },
      ]} />
    </div>
  );
}
